import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=7be13688&scoped=true"
import script from "./InsuranceList.vue?vue&type=script&lang=js"
export * from "./InsuranceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be13688",
  null
  
)

export default component.exports